window.Popper = require('popper.js').default;

require('./main');
require('./menu');
require('./block-slideshow');
require('./block-image');
